import { render, staticRenderFns } from "./code-value.vue?vue&type=template&id=1d33fa05&scoped=true&"
import script from "./code-value.vue?vue&type=script&lang=js&"
export * from "./code-value.vue?vue&type=script&lang=js&"
import style0 from "./code-value.vue?vue&type=style&index=0&id=1d33fa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d33fa05",
  null
  
)

export default component.exports